import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';
import {
    LOADING,
} from '../../../types';
import MessageUtils from "../../../../utils/MessageUtils";
import _ from "lodash";

export const updateDeliveryZones = (restaurantId, currentDeliveryZone, loadDeliveryZones, setDeliveryPartner, toggleNewDeliveryZone) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/settings/${restaurantId}/delivery/zone`;

        let updatedDeliveryZone = _.omit(currentDeliveryZone, ['removeLargeMap']);

        if (updatedDeliveryZone.deliveryZoneCircleRange) {
            if (!updatedDeliveryZone.deliveryZoneCircleRange.measureUnit) {
                updatedDeliveryZone.deliveryZoneCircleRange = null;
            }
        };

        // If no maximumOrderAmount set it to null so the server dont throw an error
        if (updatedDeliveryZone.maximumOrderAmount === 0) {
            updatedDeliveryZone.maximumOrderAmount = null;
        };

        // If verticesCoordinates is null set it to empty array so the validations work
        if (updatedDeliveryZone.verticesCoordinates === null) {
            updatedDeliveryZone.verticesCoordinates = [];
        };
        axios().post(url, updatedDeliveryZone)
            .then(response => updateDeliveryZonesSuccess(dispatch, response, loadDeliveryZones, setDeliveryPartner, toggleNewDeliveryZone))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:deliveryZonesActions.updateDeliveryZoneFailure')));
    }
};

const updateDeliveryZonesSuccess = (dispatch, response, loadDeliveryZones, setDeliveryPartner, toggleNewDeliveryZone) => {
    setDeliveryPartner(response.data.id, loadDeliveryZones);
    if (toggleNewDeliveryZone) {
        toggleNewDeliveryZone();
    }
    dispatch({ type: LOADING, payload: false });
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:deliveryZonesActions.updateDeliveryZoneSuccess'));
};

export const deleteDeliveryZone = (restaurantId, deliveryZoneId, loadDeliveryZones) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/settings/${restaurantId}/delivery/zone/${deliveryZoneId}`;

        axios().delete(url)
            .then(response => deletedDeliveryZoneSuccess(dispatch, response, loadDeliveryZones))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:deliveryZonesActions.deleteDeliveryZoneFailure')));
    }
};

const deletedDeliveryZoneSuccess = (dispatch, response, loadDeliveryZones) => {
    dispatch({ type: LOADING, payload: false });
    loadDeliveryZones();
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:deliveryZonesActions.deleteDeliveryZoneSuccess'));
};



// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/service/DeliveryZonesActions.js